import { popupController } from './privacy-policy/popup.js';

popupController();

export { popupController } from './privacy-policy/popup.js';
